<template>
    <div>
        <div class="flex justify-content-between">
            <div>
                <button v-for="(tab, index) in tabs" :key="tab+index" @click="changeSelectedTab(tab)"
                        :class="['btn mr-2 btn-primary', { active: selected === tab.view }]">
                    {{ tab.label }}
                </button>
            </div>
            <div>
                <span class="mr-3 font-bold">{{(automationsLimit === -1)? 'Unlimited': automationsCount +' / '+ automationsLimit}}</span>

                <a v-if="selected === 'MyAutomations' || (selected === 'CompanyAutomations' && eligibleUserRolesForCreateCompanyAutomation.includes(userRole))" class="btn btn-primary" :href="createAutomations">Create</a>
                <button class="btn btn-secondary" data-toggle="modal" data-target="#premadeAutomationsModal">Pre-made Automations</button>
            </div>
        </div>
        <hr/>
        <component :is="selected" class="tab" :user-id="userId" :can-share="canShare" :dateRange="dateRange" :fixedDateRangeIdentifier="fixedDateRangeIdentifier" :masks="masks" :userRole="userRole">
            <slot></slot>
        </component>

        <div id="premadeAutomationsModal" class="modal fade" role="dialog">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <!-- Modal content-->
                <div class="modal-content schedule-modal">
                    <div class="modal-body text-dark p-0">
                        <h4 class="text-center mb-2">Pre-made Automations</h4>
                        <div class="w-100 border-1">
                            <table class="table-striped w-100">
                                <tbody>
                                <tr v-for="(automation) in preMadeAutomations" class="pointer" :key="automation.id" @click="selectPreMadeAutomation(automation)" :class="(selectedPreMadeAutomation && selectedPreMadeAutomation === automation.id) ? 'selected-automation' : ''">
                                    <td class="p-2">{{ automation.pre_made_title }}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="text-right mt-4">
<!--                            route('automation.copy-automation', {automation: id})-->
                            <a class="btn btn-primary" :href="selectedPreMadeAutomation ?  customizeAutomationRoute : '#' ">Use and Customize</a>
<!--                            <button class="btn btn-primary">-->
<!--                                Create-->
<!--                            </button>-->

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import MyAutomations from "./my-automations";
    import CompanyAutomations from "./company-automations";
    import AutomationLogs from "./automation-logs";

    export default {
        name:'automation-index',
        components: {MyAutomations, CompanyAutomations, AutomationLogs},
        props: ['userId', 'dateRange', 'fixedDateRangeIdentifier',  'masks', 'automationsLimit', 'automationsCount', 'preMadeAutomations', 'canShare', 'userRole'],
        data() {
            return {
                tabs: [{'label':'My Automations', 'view': 'MyAutomations' }, {'label': 'Company Automations', 'view': 'CompanyAutomations'},
                        {'label': 'Automation Logs', 'view': 'AutomationLogs'}],
                selected: "MyAutomations",
                selectedPreMadeAutomation: null,
                eligibleUserRolesForCreateCompanyAutomation: ['owner', 'admin', 'administrative']
            }
        },
        computed: {
            createAutomations() {
                if(this.selected === 'CompanyAutomations' && this.eligibleUserRolesForCreateCompanyAutomation.includes(this.userRole)) {
                    return route('automation.create') + '?is_shared=true';
                }
                return route('automation.create');
            },
            customizeAutomationRoute() {
                return route('automation.customize-automation', {automation: this.selectedPreMadeAutomation})
            }
        },
        mounted() {
            this.selected = localStorage.getItem('currentAutomationTab') ? localStorage.getItem('currentAutomationTab') : 'MyAutomations';
        },
        methods: {
            selectPreMadeAutomation(automation) {
                if (this.selectedPreMadeAutomation === automation.id) {
                    this.selectedPreMadeAutomation = null
                }else{
                    this.selectedPreMadeAutomation = automation.id
                }

                console.log("selected pre made automation is ", automation.pre_made_title);
            },
            changeSelectedTab(tab) {
                this.selected = tab.view;
                localStorage.setItem('currentAutomationTab', tab.view);
            }
        }
    }
</script>
<style scoped>
.selected-automation {
    background: #98AFC7 !important;
}
</style>
